// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__qwjTj"};